<template>
	<div>
		<header role="banner">
			<h1 class="brand">
				<span v-if="!partnerLogo" v-html="partnerName"/>
				<img v-else :alt="partnerName" :src="partnerLogo" class="brand__img"/>
			</h1>
		</header>
		<main role="main">
			<div class="content-safe-space">
				<slot/>
			</div>
		</main>
		<Modal/>
	</div>
</template>
<script>
import watchesWindowResizeEvent from "../../../mixins/watchesWindowResizeEvent";

export default {
	mixins: [
		watchesWindowResizeEvent,
	],

	data() {
		return {
			expanded: false,
			showNav: false,
			timeout: null,
			routerViewKey: 0,
		};
	},
};
</script>
